import React from 'react';

import Input from '../Input';
import css from './index.css';
import {IconCheck, IconLinked ,IconUnlinked , IconLinkpending} from '~/components/pages/MyAccount/share/AccountIcon'


const ContactInfoFromWrap = (props) => (
  <div className={css.formWrap}>
    <form >
      <Input
        mods={['floatLef', 'half']}
        title={'First Name'}
        label={'basicFirstName'}
        type='text'
        defaultValue={props.contactInfo.basicFirstName}
        fnChange={props.handleChange}
        fnBlur={props.handleBlur}
        error={props.errorControl.basicFirstName ? props.errorControl.basicFirstName.error : ''}
      />
      <Input
        mods={['floatRigt', 'half']}
        title={'Last Name'}
        label={'basicLastName'}
        type='text'
        defaultValue={props.contactInfo.basicLastName}
        fnBlur={props.handleBlur}
        fnChange={props.handleChange}
        error={props.errorControl.basicLastName ? props.errorControl.basicLastName.error : ''}
      />
      <Input
        mods={['floatLef', 'half']}
        title={'Phone'}
        label={'basicPhone'}
        type='phone'
        defaultValue={props.contactInfo.basicPhone}
        fnBlur={props.handleBlur}
        fnChange={props.handleBlur}
        error={props.errorControl.basicPhone ? props.errorControl.basicPhone.error : ''}
        suffix={props.verifyStatus.isPhoneCheck&&IconCheck}
      />
      <Input
        mods={['floatRigt', 'half']}
        title={'Company'}
        label={'basicCompany'}
        type='text'
        readonly
        defaultValue={props.contactInfo.basicCompany}
        fnFoucs={()=>!props.dotModStatus&&props.dotUneditable()}
        error={props.errorControl.basicCompany ? props.errorControl.basicCompany.error : ''}
      />
      <Input
        mods={['floatLef', 'half']}
        title={'DOT'}
        label={'basicDot'}
        type='dot'
        readonly = {!props.dotModStatus}
        defaultValue={props.contactInfo.basicDot}
        fnChange={props.handleBlur}
        fnBlur={props.handleDotMcBlur}
        fnFoucs={()=>!props.dotModStatus&&props.dotUneditable()}
        error={props.errorControl.basicDot ? props.errorControl.basicDot.error : ''}
        suffix={(()=>{
          switch(props.verifyStatus.isDotLink){
            case "Unlinked":
              return IconUnlinked
            case "Pending":
              return IconLinkpending
            case "Linked":
              return IconLinked
          }
        })()}
      />
      <Input
        mods={['floatRigt', 'half']}
        title={'MC'}
        type='mc'
        label={'basicMc'}
        readonly
        defaultValue={props.contactInfo.basicMc}
        fnFoucs={()=>!props.dotModStatus&&props.dotUneditable()}
        error={props.errorControl.basicMc ? props.errorControl.basicMc.error : ''}
      />
      <Input
        mods={['floatRigt', 'strench']}
        title={'Identity'}
        label={'basicIdentity'}
        placeholder='Fleet manager / Ind. owner operator …'
        type='text'
        defaultValue={props.contactInfo.basicIdentity}
        fnBlur={props.handleBlur}
        fnChange={props.handleChange}
        error={props.errorControl.basicIdentity ? props.errorControl.basicIdentity.error : ''}
      />

    </form>
  </div>);

export default ContactInfoFromWrap;





// WEBPACK FOOTER //
// ./src/components/pages/MyAccount/share/ContactInfoFormWrap/index.js